export default class ContractAssociatedModel {
    idAssociado: string | null;
    idClube: string | null;

    nome: string | null;
    telefoneEmp: string | null;
    cpf: string | null;
    cep: string | null;
    logradouro: string | null;
    numero: string | null;
    complemento: string | null;
    bairro: string | null;
    idCidade: string | null;
    uf: number | string | null; // Pode ser número ou string dependendo da API
    emailCob: string | null;
    contatoEmp: string | null;
    celularCob: string | null;

    // Campos API ANTIGA (opcionais)
    estado: string | null;
    cidade: string | null;

    constructor(
        idAssociado: string | null,
        idClube: string | null,
        nome: string | null,
        telefoneEmp: string | null,
        cpf: string | null,
        cep: string | null,
        logradouro: string | null,
        numero: string | null,
        complemento: string | null,
        bairro: string | null,
        idCidade: string | null,
        uf: number | string | null,
        emailCob: string | null,
        contatoEmp: string | null,
        celularCob: string | null,
        estado: string | null,
        cidade: string | null
    ) {
        this.idAssociado = idAssociado;
        this.idClube = idClube;

        this.nome = nome;
        this.telefoneEmp = telefoneEmp;
        this.cpf = cpf;
        this.cep = cep;
        this.logradouro = logradouro;
        this.numero = numero;
        this.complemento = complemento;
        this.bairro = bairro;
        this.idCidade = idCidade;
        this.uf = uf;
        this.emailCob = emailCob;
        this.contatoEmp = contatoEmp;
        this.celularCob = celularCob;

        this.estado = estado;
        this.cidade = cidade;
    }

    static fromApiResponse(data: any): ContractAssociatedModel {
        return new ContractAssociatedModel(
            data.id_associado || null,
            data.id_clube || null,
            data.nome || null,
            data.TELEFONE_EMP || null,
            data.cpf || null,
            data.cep || null,
            data.logradouro || null,
            data.numero || null,
            data.complemento || null,
            data.bairro || null,
            data.id_cidade || null,
            data.uf ?? data.cidade?.uf ?? null, // compatível com API antiga e nova
            data.EMAIL_COB || null,
            data.CONTATO_EMP || null,
            data.CELULAR_COB || null,

            // API antiga (opcional)
            data.cidade?.uf || null,
            data.cidade?.nome_municipio || null
        );
    }
}
